import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { Counter } from "../components/Counter";
import { CtaBanner } from "./Home";
import { IMG, TIMELINE, STATS, WHY } from "../data/site";
import { ShieldCheck, Award, Target, HeartHandshake } from "lucide-react";

const values = [
  { icon: Target, title: "Our Mission", body: "To give builders and property developers certainty through reliable project delivery, quality workmanship and practical problem-solving — combining family-business accountability with the capability to operate at scale." },
  { icon: HeartHandshake, title: "Our Values", body: "Honesty, craftsmanship and genuine care in every job, big or small." },
  { icon: ShieldCheck, title: "Safety First", body: "Fully licensed, insured and safety-accredited on every site." },
  { icon: Award, title: "Licences & Insurance", body: "ARCtick refrigerant handling licence, VBA registered and fully insured." },
];

const About = () => (
  <div data-testid="about-page">
    <PageHero eyebrow="ABOUT J&S" title="A Melbourne family business since 1988" subtitle="Three decades of premium heating and cooling — built on trust, craftsmanship and genuine care." image={IMG.commercialTeam} crumbs={[{ label: "About" }]} />

    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal>
          <span className="text-js-blue font-semibold text-sm tracking-wide">OUR STORY</span>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight mt-3 mb-6">Built on doing things properly</h2>
          <p className="text-js-charcoal/60 leading-relaxed mb-4">What started as a small family operation in 1988 has grown into one of Melbourne's most trusted HVAC specialists. Yet our promise hasn't changed: honest advice, premium products and workmanship we're proud to put our name on.</p>
          <p className="text-js-charcoal/60 leading-relaxed">Today we design, install and maintain heating and cooling for homes and businesses right across greater Melbourne — from single split systems to complex commercial fitouts.</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="rounded-3xl overflow-hidden h-[440px] border border-black/5 shadow-[0_20px_50px_rgba(0,0,0,0.08)]">
            <img src={IMG.tech1} alt="J&S technicians" className="w-full h-full object-cover" />
          </div>
        </Reveal>
      </div>
    </section>

    <section className="py-24 bg-js-blue text-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-2 lg:grid-cols-4 gap-10">
        {STATS.map((s) => (
          <Reveal key={s.label} className="text-center">
            <div className="font-display font-extrabold text-5xl md:text-6xl tracking-tight"><Counter value={s.value} suffix={s.suffix} /></div>
            <p className="text-white/70 mt-2 text-sm">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </section>

    {/* TIMELINE */}
    <section className="py-24 md:py-32 bg-js-grey">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <Reveal className="mb-16">
          <span className="text-js-blue font-semibold text-sm tracking-wide">OUR JOURNEY</span>
          <h2 className="font-display font-extrabold text-4xl md:text-5xl tracking-tight mt-3">From 1988 to today</h2>
        </Reveal>
        <div className="relative border-l-2 border-js-blue/20 ml-3">
          {TIMELINE.map((t, i) => (
            <Reveal key={t.year} delay={i * 0.05}>
              <div className="relative pl-10 pb-12 last:pb-0">
                <span className="absolute -left-[9px] top-1 w-4 h-4 rounded-full bg-js-blue ring-4 ring-js-grey" />
                <span className="font-display font-extrabold text-2xl text-js-blue">{t.year}</span>
                <h3 className="font-display font-bold text-xl mt-1">{t.title}</h3>
                <p className="text-js-charcoal/60 mt-1 leading-relaxed">{t.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    {/* VALUES */}
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {values.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.05}>
              <div className="bg-js-grey rounded-3xl p-8 border border-black/5 h-full">
                <span className="grid place-items-center w-12 h-12 rounded-xl bg-js-blue text-white mb-5"><v.icon size={22} /></span>
                <h3 className="font-display font-bold text-lg mb-2">{v.title}</h3>
                <p className="text-js-charcoal/60 text-sm leading-relaxed">{v.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
    <CtaBanner />
  </div>
);

export default About;
